module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/btn_3_sp_00eb77d716c85bf09cbc4a435f99c18c.png";